import { Stack, Pagination, Box } from "@mui/material";
import { useState } from "react";
import { WalkthroughAttachmentOut } from "@providers/hop-ord-server/api";
import { ImagePreviewModal } from "@components/OrderTrackingFileList/PreviewModals";
import dayjs from "dayjs";

type Props = {
  images: WalkthroughAttachmentOut[];
};

const ImageCarousel = ({ images }: Props) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [open, setOpen] = useState(false);

  const handlePageChange = (_: unknown, value: number) => {
    setCurrentPage(value - 1);
  };

  const selectedImage = images[currentPage];

  return (
    <Stack gap={2} alignItems="center" data-testid="image-carousel">
      {images.map((image, index) => (
        <Box
          key={index}
          onClick={() => setOpen(true)}
          sx={{
            display: currentPage === index ? "flex" : "none",
            height: "512px",
            width: 1,
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={image.file}
            alt={image.fileName}
            sx={{
              borderRadius: 2,
              maxHeight: 1,
              maxWidth: 1,
              backgroundColor: "black",
              objectFit: "contain",
            }}
          />
        </Box>
      ))}
      <Pagination
        count={images.length}
        page={currentPage + 1}
        onChange={handlePageChange}
      />
      <ImagePreviewModal
        title={selectedImage.fileName}
        src={selectedImage.file}
        alt={selectedImage.fileName}
        size={selectedImage.fileSize}
        createdAt={dayjs(selectedImage.createdAt)}
        open={open}
        onClose={() => setOpen(false)}
        onNext={() => setCurrentPage((v) => (v + 1) % images.length)}
        onPrevious={() =>
          setCurrentPage((v) => (v - 1 + images.length) % images.length)
        }
      />
    </Stack>
  );
};

export default ImageCarousel;
